import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideSuccessBankAddedPopup } from '../../../actions';
import { CardForm, CustomPortal } from '../../../commonComponents';
import { resetInviteProfessionals } from '../../../domain/utils';
import { OutlineCreditCardIcon } from '@tempmee/react-icons';
import { useModal } from '../../ModalQueue';
import { ModalOrder } from '../../ModalQueue/modalOrder';
import ConfirmPopup from '../../shared/ConfirmPopup';
import { addExpirationDate } from '../utils';
import { PaymentCard } from './PaymentCard';

export const CardList = ({ selectedPayment, setSelectedPayment }) => {
  const dispatch = useDispatch();
  const allPayments = useSelector((state) => state.payments.allPayments);
  const cardList = allPayments
    ?.filter((item) => item.type === 'card')
    .sort((a, b) => (b.is_selected === true) - (a.is_selected === true))
    .map((item) => addExpirationDate(item));
  const [showAddCardPopup, setShowAddCardPopup] = useState(false);
  const showSuccessCardAddedPopup = useSelector(
    (state) => state.payments.showSuccessCardAddedPopup,
  );

  const { isActive: isSuccessPopupActive } = useModal({
    id: ModalOrder.CARD_SUCCESS_POPUP,
    condition: showSuccessCardAddedPopup,
  });

  return (
    <>
      <PaymentCard
        dataCy="card-list-payment"
        data={cardList}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
        IconComponent={OutlineCreditCardIcon}
        title="Credit Card / Debit Card"
        description="(Adding a Credit/Debit Card comes with a 3.5% Convenience Fee on each transaction)."
        addPaymentText="Add Credit Card / Debit Card"
        handleAddPaymentButton={() => setShowAddCardPopup(true)}
        showExpiration
      />

      {showAddCardPopup && (
        <ConfirmPopup
          dataCy="card-list-payment-add-card-popup"
          showClosePopupIcon
          closePopup={() => setShowAddCardPopup(false)}
          closePopupDataCy="card-list-payment-add-card-close-popup"
          title="Add Credit Card / Debit Card"
          description={
            <CardForm
              onSuccess={() => {
                setShowAddCardPopup(false);
                resetInviteProfessionals();
              }}
            />
          }
        />
      )}

      {isSuccessPopupActive && (
        <CustomPortal
          dataCy="card-list-payment-success-popup"
          isSuccess
          redirect={false}
          title="Card Successfully Added!"
          text="Your credit / debit card has been successfully added to your account."
          submitPressed={() => {
            dispatch(hideSuccessBankAddedPopup());
          }}
          rightButtonDataCy="btn-ok"
        />
      )}
    </>
  );
};
